/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
  .st0 {
    fill: ${(props) => props.theme.palette.highlight.main};
  }
  .st1 {
    fill: ${(props) => props.theme.palette.common.white};
  }
`;
export const SVG = ({ className }: { className?: string }) => (
  <StyledSVG className={className} version='1.1' id='Ebene_1' x='0px' y='0px' viewBox='0 0 572 157'>
    <path
      id='XMLID_160_'
      className='st0'
      d='M112.5,56.9c-1.9-3.5-6.2-4.8-9.7-3L70,71.4L37.9,53.9c-3.5-1.9-7.8-0.6-9.7,2.9
  c-1.9,3.5-0.6,7.8,2.9,9.7l31.8,17.3v36.1c0,4,3.2,7.2,7.2,7.2c4,0,7.2-3.2,7.2-7.2v-36l32.4-17.3C113.1,64.7,114.4,60.4,112.5,56.9
  z'
    />
    <g id='XMLID_154_'>
      <g id='XMLID_155_'>
        <path
          id='XMLID_156_'
          className='st1'
          d='M69.9,154.4c-0.9,0-1.7-0.2-2.5-0.7L6,118.3c-1.6-0.9-2.5-2.6-2.5-4.4V43.1
      c0-1.8,1-3.5,2.5-4.4L67.4,3.3c1.6-0.9,3.5-0.9,5,0l61.4,35.4c1.6,0.9,2.5,2.6,2.5,4.4v70.9c0,1.8-1,3.5-2.5,4.4l-61.4,35.4
      C71.6,154.2,70.8,154.4,69.9,154.4z M13.5,111l56.4,32.5l56.4-32.5V46L69.9,13.4L13.5,46V111z'
        />
      </g>
    </g>
    <g id='XMLID_152_'>
      <path
        id='XMLID_153_'
        className='st1'
        d='M209.6,50.4c-0.2,1.9-0.4,3.8-0.8,5.5h-15.5v56.4h-12.5V55.9h-16.1v-11h45.1
    C209.9,46.6,209.8,48.5,209.6,50.4'
      />
    </g>
    <g id='XMLID_142_'>
      <path
        id='XMLID_147_'
        transform='translate(-150)'
        className='st1'
        d='M427.6,78.4c0-4.5-0.5-8.2-1.4-11.1c-0.9-3-2.2-5.3-3.7-7.1c-1.5-1.8-3.3-3.1-5.4-3.8
    c-2.1-0.7-4.3-1.1-6.6-1.1c-1.5,0-3.1,0.1-5,0.1c-1.9,0.1-3.6,0.2-5.1,0.3v46c1.3,0.1,3,0.2,4.9,0.3c1.9,0.1,3.6,0.1,5.1,0.1
    c5.7,0,10-1.9,12.9-5.6C426.1,92.8,427.6,86.7,427.6,78.4 M441,77.2c0,5.8-0.7,10.9-2.2,15.4c-1.5,4.5-3.6,8.3-6.2,11.3
    s-5.8,5.3-9.5,6.9c-3.7,1.6-7.7,2.3-12.1,2.3c-1.7,0-3.6,0-5.6-0.1c-2-0.1-4.1-0.2-6.1-0.3c-2-0.1-4-0.2-6-0.4
    c-2-0.2-3.7-0.4-5.2-0.6V45.6c1.4-0.2,3.1-0.4,5.1-0.5c2-0.2,4.1-0.3,6.2-0.4c2.1-0.1,4.2-0.2,6.3-0.3c2.1-0.1,3.8-0.1,5.3-0.1
    c4.1,0,8,0.6,11.7,1.8c3.7,1.2,6.9,3.2,9.6,5.8c2.7,2.7,4.9,6.1,6.5,10.2C440.2,66.3,441,71.3,441,77.2'
      />
      <path
        id='XMLID_144_'
        transform='translate(-150)'
        className='st1'
        d='M490.8,62.7c-0.3-0.8-0.5-1.6-0.5-2.4c-0.1-0.8-0.2-1.7-0.3-2.8h-0.8c-0.1,1.1-0.1,2-0.2,2.8
    c-0.1,0.8-0.2,1.6-0.5,2.4L482,84.1h15.2L490.8,62.7z M517.9,111.7c-1.9,0.4-3.9,0.7-5.9,0.9c-2,0.2-4.1,0.2-6.2,0.2l-5.5-18.4
    h-21.1l-5.5,18.4c-1.9,0-3.8-0.1-5.7-0.2c-2-0.2-3.8-0.5-5.5-0.9c3.1-10.9,6.3-21.9,9.8-33c3.5-11.1,7.2-22.3,11.2-33.7h13.7
    c3.7,11.2,7.3,22.4,10.8,33.7C511.4,89.8,514.7,100.9,517.9,111.7'
      />
    </g>
    <g id='XMLID_20_'>
      <path
        id='XMLID_133_'
        className='st0'
        d='M235.9,127c0,0.5-0.1,1-0.2,1.5h-4.1v15.1h-3.3v-15.1h-4.3v-2.9h12.1
    C235.9,126,235.9,126.5,235.9,127z'
      />
      <path id='XMLID_135_' className='st0' d='M249.3,143.6v-7.9h-6.9v7.9H239v-18h3.3v7.1h6.9v-7.1h3.3v18H249.3z' />
      <path
        id='XMLID_137_'
        className='st0'
        d='M268.2,142.1c-0.1,0.5-0.1,1-0.2,1.5h-10.5v-18h10.3c0,0.4,0,0.9-0.1,1.5c0,0.5-0.1,1-0.2,1.5
    h-6.7v4.4h5v2.9h-5v4.9h7.4C268.3,141.1,268.3,141.6,268.2,142.1z'
      />
      <path
        id='XMLID_139_'
        className='st0'
        d='M283.3,143.6c-0.6,0.1-1.2,0.1-1.8,0.1l-1.3-2.8c-0.5-1-1-1.9-1.4-2.7
    c-0.5-0.8-0.9-1.4-1.3-1.8h-2.1v7.1h-3.3v-17.8c1.1-0.1,2.1-0.2,3-0.3c0.9-0.1,1.8-0.1,2.6-0.1c0.8,0,1.6,0.1,2.3,0.3
    s1.4,0.5,1.9,0.9c0.5,0.4,1,1,1.3,1.6c0.3,0.7,0.5,1.5,0.5,2.4c0,0.6-0.1,1.2-0.3,1.7c-0.2,0.5-0.4,1-0.7,1.4s-0.7,0.8-1.1,1.1
    c-0.4,0.3-0.9,0.5-1.4,0.7c1.1,0.9,2,2.2,2.8,3.9l2,4C284.4,143.5,283.9,143.6,283.3,143.6z M280.3,130.9c0-1-0.2-1.7-0.7-2.1
    s-1.2-0.7-2.1-0.7c-0.4,0-0.7,0-1.1,0s-0.7,0-1,0.1v5.8h1.8c1,0,1.7-0.2,2.3-0.7C280,132.7,280.3,131.9,280.3,130.9z'
      />
      <path
        id='XMLID_143_'
        className='st0'
        d='M306.9,143.4c-0.5,0.1-1,0.2-1.6,0.2c-0.6,0-1.1,0.1-1.6,0.1l-0.8-11.6c0-0.1,0-0.2,0-0.4
    c0-0.2,0-0.3,0-0.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.3,0-0.4h-0.2c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.4-0.1,0.6-0.2,0.8l-3.5,11.5h-3.2
    l-3.6-11.5c-0.1-0.2-0.1-0.5-0.2-0.8c-0.1-0.4-0.1-0.7-0.1-1.1h-0.2c0,0.1,0,0.3,0,0.4c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5
    c0,0.2,0,0.3,0,0.4l-1,11.6c-0.4,0-0.9,0-1.5-0.1c-0.5,0-1-0.1-1.4-0.2c0.2-3,0.4-6,0.7-8.9c0.3-2.9,0.6-5.9,0.9-9h3.8l3.8,12.1
    c0.1,0.3,0.2,0.6,0.2,1c0.1,0.4,0.1,0.7,0.1,1.1h0.2c0-0.4,0.1-0.7,0.1-1.1c0-0.4,0.1-0.7,0.2-1l3.7-12.1h3.8c0.3,3,0.6,6,0.9,9
    S306.7,140.4,306.9,143.4z'
      />
      <path
        id='XMLID_161_'
        className='st0'
        d='M324.1,143.4c-0.5,0.1-1,0.2-1.6,0.2c-0.5,0-1.1,0.1-1.7,0.1l-1.5-4.9h-5.6l-1.5,4.9
    c-0.5,0-1,0-1.5-0.1c-0.5,0-1-0.1-1.5-0.2c0.8-2.9,1.7-5.9,2.6-8.8c0.9-3,1.9-6,3-9h3.7c1,3,2,6,2.9,9
    C322.4,137.6,323.3,140.5,324.1,143.4z M316.9,130.3c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.5-0.1-0.7h-0.2c0,0.3,0,0.5-0.1,0.7
    s-0.1,0.4-0.1,0.6l-1.7,5.7h4.1L316.9,130.3z'
      />
      <path
        id='XMLID_164_'
        className='st0'
        d='M337.1,142.1c0,0.5-0.1,1-0.2,1.5H327v-18h3.3v15.1h6.8C337.2,141.1,337.2,141.6,337.1,142.1z
    '
      />
      <path
        id='XMLID_166_'
        className='st0'
        d='M360.1,134.2c0,1.6-0.2,2.9-0.6,4.1c-0.4,1.2-1,2.2-1.7,3c-0.7,0.8-1.6,1.4-2.5,1.8
    s-2.1,0.6-3.2,0.6c-0.5,0-1,0-1.5,0s-1.1,0-1.6-0.1c-0.5,0-1.1-0.1-1.6-0.1c-0.5-0.1-1-0.1-1.4-0.2v-17.7c0.4-0.1,0.8-0.1,1.4-0.1
    c0.5,0,1.1-0.1,1.7-0.1c0.6,0,1.1-0.1,1.7-0.1c0.6,0,1,0,1.4,0c1.1,0,2.1,0.2,3.1,0.5c1,0.3,1.8,0.9,2.6,1.6
    c0.7,0.7,1.3,1.6,1.7,2.7C359.9,131.3,360.1,132.6,360.1,134.2z M356.5,134.5c0-1.2-0.1-2.2-0.4-3c-0.3-0.8-0.6-1.4-1-1.9
    s-0.9-0.8-1.4-1c-0.6-0.2-1.1-0.3-1.8-0.3c-0.4,0-0.8,0-1.3,0c-0.5,0-1,0.1-1.4,0.1v12.3c0.4,0,0.8,0.1,1.3,0.1c0.5,0,1,0,1.4,0
    c1.5,0,2.7-0.5,3.5-1.5C356.1,138.3,356.5,136.7,356.5,134.5z'
      />
      <path
        id='XMLID_169_'
        className='st0'
        d='M374.7,142.1c-0.1,0.5-0.1,1-0.2,1.5H364v-18h10.3c0,0.4,0,0.9-0.1,1.5c0,0.5-0.1,1-0.2,1.5
    h-6.7v4.4h5v2.9h-5v4.9h7.4C374.8,141.1,374.8,141.6,374.7,142.1z'
      />
      <path
        id='XMLID_171_'
        className='st0'
        d='M397.3,143.4c-0.5,0.1-1,0.2-1.6,0.2c-0.6,0-1.1,0.1-1.6,0.1l-0.8-11.6c0-0.1,0-0.2,0-0.4
    c0-0.2,0-0.3,0-0.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.3,0-0.4h-0.2c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.4-0.1,0.6-0.2,0.8l-3.5,11.5h-3.2
    l-3.6-11.5c-0.1-0.2-0.1-0.5-0.2-0.8c-0.1-0.4-0.1-0.7-0.1-1.1H382c0,0.1,0,0.3,0,0.4c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5
    c0,0.2,0,0.3,0,0.4l-1,11.6c-0.4,0-0.9,0-1.5-0.1c-0.5,0-1-0.1-1.4-0.2c0.2-3,0.4-6,0.7-8.9c0.3-2.9,0.6-5.9,1-9h3.8l3.8,12.1
    c0.1,0.3,0.2,0.6,0.2,1c0.1,0.4,0.1,0.7,0.1,1.1h0.2c0-0.4,0.1-0.7,0.1-1.1c0-0.4,0.1-0.7,0.2-1l3.7-12.1h3.8c0.3,3,0.6,6,0.9,9
    S397.1,140.4,397.3,143.4z'
      />
      <path
        id='XMLID_173_'
        className='st0'
        d='M414.6,143.4c-0.5,0.1-1,0.2-1.6,0.2c-0.5,0-1.1,0.1-1.7,0.1l-1.5-4.9h-5.6l-1.5,4.9
    c-0.5,0-1,0-1.5-0.1c-0.5,0-1-0.1-1.5-0.2c0.8-2.9,1.7-5.9,2.6-8.8c0.9-3,1.9-6,3-9h3.7c1,3,2,6,2.9,9
    C412.9,137.6,413.8,140.5,414.6,143.4z M407.3,130.3c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.5-0.1-0.7h-0.2c0,0.3,0,0.5-0.1,0.7
    s-0.1,0.4-0.1,0.6L405,136h4.1L407.3,130.3z'
      />
      <path
        id='XMLID_176_'
        className='st0'
        d='M431.1,143.4c-0.2,0-0.5,0.1-0.7,0.1c-0.3,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0-0.8,0.1
    s-0.5,0-0.7,0l-6.5-11.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.2-0.2-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.5
    l-0.2,0c0,0.4,0.1,0.7,0.1,1.1c0,0.4,0,0.7,0,1v11.3h-3v-17.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.9,0
    c0.3,0,0.6,0,0.8,0l6.2,10.9c0.1,0.3,0.3,0.6,0.5,1c0.2,0.4,0.3,0.7,0.4,1.1l0.2,0c0-0.3-0.1-0.6-0.1-1.1c0-0.4,0-0.8,0-1.1v-10.6
    h3V143.4z'
      />
      <path
        id='XMLID_178_'
        className='st0'
        d='M450.2,134.2c0,1.6-0.2,2.9-0.6,4.1c-0.4,1.2-1,2.2-1.7,3c-0.7,0.8-1.6,1.4-2.5,1.8
    s-2.1,0.6-3.2,0.6c-0.5,0-1,0-1.5,0s-1.1,0-1.6-0.1c-0.5,0-1.1-0.1-1.6-0.1c-0.5-0.1-1-0.1-1.4-0.2v-17.7c0.4-0.1,0.8-0.1,1.4-0.1
    c0.5,0,1.1-0.1,1.7-0.1c0.6,0,1.1-0.1,1.7-0.1c0.6,0,1,0,1.4,0c1.1,0,2.1,0.2,3.1,0.5c1,0.3,1.8,0.9,2.6,1.6
    c0.7,0.7,1.3,1.6,1.7,2.7C450,131.3,450.2,132.6,450.2,134.2z M446.6,134.5c0-1.2-0.1-2.2-0.4-3c-0.3-0.8-0.6-1.4-1-1.9
    s-0.9-0.8-1.4-1c-0.6-0.2-1.1-0.3-1.8-0.3c-0.4,0-0.8,0-1.3,0c-0.5,0-1,0.1-1.4,0.1v12.3c0.4,0,0.8,0.1,1.3,0.1c0.5,0,1,0,1.4,0
    c1.5,0,2.7-0.5,3.5-1.5C446.3,138.3,446.6,136.7,446.6,134.5z'
      />
      <path
        id='XMLID_181_'
        className='st0'
        d='M472.4,143.4c-0.5,0.1-1,0.2-1.6,0.2c-0.5,0-1.1,0.1-1.7,0.1l-1.5-4.9H462l-1.5,4.9
    c-0.5,0-1,0-1.5-0.1c-0.5,0-1-0.1-1.5-0.2c0.8-2.9,1.7-5.9,2.6-8.8c0.9-3,1.9-6,3-9h3.7c1,3,2,6,2.9,9
    C470.7,137.6,471.6,140.5,472.4,143.4z M465.2,130.3c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.5-0.1-0.7h-0.2c0,0.3,0,0.5-0.1,0.7
    s-0.1,0.4-0.1,0.6l-1.7,5.7h4.1L465.2,130.3z'
      />
      <path
        id='XMLID_184_'
        className='st0'
        d='M488.9,143.4c-0.2,0-0.5,0.1-0.7,0.1c-0.3,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0-0.8,0.1
    s-0.5,0-0.7,0l-6.5-11.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.2-0.2-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.5
    l-0.2,0c0,0.4,0.1,0.7,0.1,1.1c0,0.4,0,0.7,0,1v11.3h-3v-17.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.9,0
    c0.3,0,0.6,0,0.8,0l6.2,10.9c0.1,0.3,0.3,0.6,0.5,1c0.2,0.4,0.3,0.7,0.4,1.1l0.2,0c0-0.3-0.1-0.6-0.1-1.1c0-0.4,0-0.8,0-1.1v-10.6
    h3V143.4z'
      />
      <path
        id='XMLID_186_'
        className='st0'
        d='M506.7,143.4c-0.5,0.1-1,0.2-1.6,0.2c-0.5,0-1.1,0.1-1.7,0.1l-1.5-4.9h-5.6l-1.5,4.9
    c-0.5,0-1,0-1.5-0.1c-0.5,0-1-0.1-1.5-0.2c0.8-2.9,1.7-5.9,2.6-8.8c0.9-3,1.9-6,3-9h3.7c1,3,2,6,2.9,9
    C504.9,137.6,505.8,140.5,506.7,143.4z M499.4,130.3c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.5-0.1-0.7H499c0,0.3,0,0.5-0.1,0.7
    s-0.1,0.4-0.1,0.6L497,136h4.1L499.4,130.3z'
      />
      <path
        id='XMLID_189_'
        className='st0'
        d='M519.6,142.1c0,0.5-0.1,1-0.2,1.5h-9.9v-18h3.3v15.1h6.8C519.7,141.1,519.7,141.6,519.6,142.1
    z'
      />
      <path
        id='XMLID_191_'
        className='st0'
        d='M533.4,125.7c-0.8,2-1.7,3.9-2.5,5.7c-0.9,1.8-1.8,3.7-2.8,5.5v6.6h-3.3V137
    c-1-1.9-2-3.8-2.8-5.6c-0.9-1.9-1.7-3.7-2.5-5.6c0.2-0.1,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,1-0.1c0.3,0,0.6,0,0.9-0.1
    c0.3,0,0.5,0,0.8,0l3,6.9c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.2,0.5,0.2,0.7h0.2c0.1-0.2,0.2-0.5,0.3-0.8c0.1-0.3,0.2-0.5,0.3-0.8
    l3-6.8c0.5,0,1,0,1.6,0.1C532.3,125.5,532.9,125.6,533.4,125.7z'
      />
      <path
        id='XMLID_193_'
        className='st0'
        d='M546.6,138.4c0,0.9-0.2,1.6-0.5,2.3c-0.3,0.7-0.7,1.2-1.3,1.7c-0.6,0.5-1.2,0.8-2,1
    c-0.8,0.2-1.6,0.3-2.6,0.3c-0.7,0-1.6-0.1-2.4-0.2c-0.9-0.1-1.7-0.3-2.4-0.7c0.1-0.5,0.2-1,0.3-1.5c0.1-0.5,0.2-1,0.4-1.4
    c0.7,0.3,1.4,0.5,2.2,0.7s1.6,0.2,2.3,0.2c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-0.9,0.6-1.7c0-0.6-0.2-1-0.6-1.4
    c-0.4-0.4-0.9-0.7-1.4-1c-0.6-0.3-1.2-0.6-1.9-0.9c-0.7-0.3-1.3-0.7-1.9-1.1s-1-0.9-1.4-1.5c-0.4-0.6-0.6-1.4-0.6-2.2
    c0-0.9,0.2-1.6,0.5-2.2c0.3-0.6,0.8-1.2,1.4-1.6c0.6-0.4,1.3-0.8,2.1-1c0.8-0.2,1.7-0.3,2.6-0.3c0.6,0,1.2,0,1.9,0.1s1.3,0.2,2,0.3
    c0,0.4-0.1,0.9-0.2,1.4c-0.1,0.5-0.2,1-0.3,1.5c-0.6-0.1-1.3-0.3-2-0.3c-0.7-0.1-1.4-0.1-2-0.1c-0.9,0-1.6,0.2-2,0.6
    c-0.4,0.4-0.6,0.9-0.6,1.6c0,0.5,0.2,0.9,0.6,1.3c0.4,0.4,0.9,0.7,1.4,1c0.6,0.3,1.2,0.6,1.9,0.9s1.3,0.7,1.9,1.1
    c0.6,0.4,1,1,1.4,1.6S546.6,137.6,546.6,138.4z'
      />
      <path id='XMLID_195_' className='st0' d='M550.5,143.6v-18h3.3v18H550.5z' />
      <path
        id='XMLID_197_'
        className='st0'
        d='M569,138.4c0,0.9-0.2,1.6-0.5,2.3c-0.3,0.7-0.7,1.2-1.3,1.7c-0.6,0.5-1.2,0.8-2,1
    c-0.8,0.2-1.6,0.3-2.6,0.3c-0.7,0-1.6-0.1-2.4-0.2c-0.9-0.1-1.7-0.3-2.4-0.7c0.1-0.5,0.2-1,0.3-1.5c0.1-0.5,0.2-1,0.4-1.4
    c0.7,0.3,1.4,0.5,2.2,0.7s1.6,0.2,2.3,0.2c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-0.9,0.6-1.7c0-0.6-0.2-1-0.6-1.4
    c-0.4-0.4-0.9-0.7-1.4-1c-0.6-0.3-1.2-0.6-1.9-0.9c-0.7-0.3-1.3-0.7-1.9-1.1s-1-0.9-1.4-1.5c-0.4-0.6-0.6-1.4-0.6-2.2
    c0-0.9,0.2-1.6,0.5-2.2c0.3-0.6,0.8-1.2,1.4-1.6c0.6-0.4,1.3-0.8,2.1-1c0.8-0.2,1.7-0.3,2.6-0.3c0.6,0,1.2,0,1.9,0.1s1.3,0.2,2,0.3
    c0,0.4-0.1,0.9-0.2,1.4c-0.1,0.5-0.2,1-0.3,1.5c-0.6-0.1-1.3-0.3-2-0.3c-0.7-0.1-1.4-0.1-2-0.1c-0.9,0-1.6,0.2-2,0.6
    c-0.4,0.4-0.6,0.9-0.6,1.6c0,0.5,0.2,0.9,0.6,1.3c0.4,0.4,0.9,0.7,1.4,1c0.6,0.3,1.2,0.6,1.9,0.9s1.3,0.7,1.9,1.1
    c0.6,0.4,1,1,1.4,1.6S569,137.6,569,138.4z'
      />
    </g>
  </StyledSVG>
);
export default SVG;
